<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
            <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
                <el-input v-model.trim="dioForm.extPanId" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('Join Attemp')" prop="channelPage">
                <el-input v-model.trim="dioForm.channelPage" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
                <el-input v-model.trim="dioForm.channelMask" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>

            <el-form-item :label="$t('device.transmit_power')" prop="transmitPower">
                <el-input v-model.trim="dioForm.transmitPower" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>

            <el-form-item :label="$t('integration.network_access_interval_(seconds)')" prop="inNetInterval">
                <el-input v-model.trim="dioForm.inNetInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { relayUpdateNetConfig } from '@/api/modules/relay.js'
import { addNetRules } from '../validate/addRules'

export default {
  props: ['title', 'isShow', 'choozeTableData'],
  watch: {
    choozeTableData (newVal) {
      this.tableData = [...newVal]
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    rules () {
      const rules = addNetRules(['extPanId', 'channelPage', 'channelMask', 'transmitPower', 'inNetInterval'])
      return rules
    }
  },
  data () {
    return {
      dioForm: {
        extPanId: null,
        channelPage: null,
        channelMask: null,
        transmitPower: null,
        inNetInterval: null
      },
      tableData: []
    }
  },
  methods: {
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const flag = await this.justify()
      if (!flag) return
      const idList = this.tableData.map(item => item.id)
      const query = Object.assign({}, this.dioForm, { idList })
      relayUpdateNetConfig(query).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.update_successful'))
          this.isShowDialog = false
          this.$parent.getListFn()
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style></style>
